import createEnum from 'scripts/lib/create_enum';

const LiveboardType = createEnum('AGENTS', 'SUMMARY', 'TOPICS');

export default LiveboardType;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/liveboards/liveboard_type.js